import React, { createContext, Dispatch, SetStateAction } from 'react'
import Box from '@material-ui/core/Box'
import StateProvider from '../../../providers/default/StateProvider'
import ScrollablePaper from '../../../components/default/present/ScrollablePaper'
import FinancePiggyToolbar, { FinancePiggyToolbarFormType } from '../../../components/admin/finance/FinancePiggyToolbar'
import FinancePiggyAlipayTable from '../../../components/admin/finance/FinancePiggyAlipayTable'
import useT from '../../../i18ns/admin/useT'
import { Path } from '../../../components/admin/route/route'

export const FormContext = createContext<[FinancePiggyToolbarFormType, Dispatch<SetStateAction<FinancePiggyToolbarFormType>>]>([
  {
    status: '--',
    account: '',
    page: 1
  },
  () => {}
])

const FinancePiggyAlipayPage: React.FC = () => {
  const { t } = useT()
  return (
    <Box paddingY={5}>
      <ScrollablePaper marginX={5}>
        <StateProvider
          context={FormContext}
          defaultValue={{ status: '--', account: '', page: 1 }}
        >
          <Box padding={4}>
            <FinancePiggyToolbar
              context={FormContext}
              namePlaceholder={t('placeholder.inputSearchAlipayAccount')}
              createLink={Path.FINANCE_PIGGY_ALIPAY_CREATE}
              createTitle={t('page.createPiggyAlipay')}
            />
          </Box>
          <Box paddingTop={1} paddingBottom={5} paddingX={4}>
            <FinancePiggyAlipayTable />
          </Box>
        </StateProvider>
      </ScrollablePaper>
    </Box>
  )
}

export default React.memo(FinancePiggyAlipayPage)
